import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { panelStyles } from "../PanelStyles";
import { ReactComponent as SourcesLibraryIcon } from "../../assets/icons/Sources-Dark.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/sidebar-close.svg";

interface SourcesHeaderProps {
  isPanelExpanded: boolean;
  handleUnexpand: () => void;
}

const SourcesHeader: React.FC<SourcesHeaderProps> = ({
  isPanelExpanded,
  handleUnexpand,
}) => {
  return (
    <Box
      sx={{
        ...panelStyles.header,
        justifyContent: "space-between",
        gap: "8px",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      {/* Materiom Formulations toggle buttons is disabled for now */}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <SourcesLibraryIcon />
          <Typography sx={panelStyles.headerTitle}>Sources Library</Typography>
        </Box>
        <Typography
          variant="subtitle2"
          sx={{ color: "text.secondary", pl: 2.5, pt: 1 }}
        >
          I am interested in searching:
        </Typography>
      </Box>
      {isPanelExpanded && (
        <Tooltip title="Collapse panel" placement="left">
          <IconButton
            onClick={handleUnexpand}
            size="small"
            sx={{ color: "text.secondary" }}
          >
            <CloseIcon fontSize="medium" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default SourcesHeader;
